var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContent',[_c('b-row',[_c('b-col',{attrs:{"cols":"3"}}),_c('b-col',{attrs:{"cols":"6"}},[_c('LoginCpsForm',{staticClass:"p-4 border"})],1),_c('b-col',{attrs:{"cols":"3"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }